import { useContext } from 'react';
import * as React from 'react';

import {
  Box,
  Hidden,
  IconButton,
  Button,
  Link,
  Tooltip,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import HeaderMenu from './Menu';
import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import Logo from 'src/components/Logo';
import ChangeBranch from 'src/pages/MyAccount/ChangeBranch';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';

import { useSearchParams } from 'react-router-dom';
import HeaderAdminbox from 'src/layouts/AdminLayout/Header/AdminBox';
import { useSelector } from 'react-redux'
import { selectSideBarActiveLink} from '../../../features/chat/layoutSlice'

// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: 60px;
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 5;
        background-color: ${theme.header.background};
        box-shadow: ${theme.header.boxShadow};
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: ${theme.sidebar.width};
            width: auto;
        }
`
);

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);
const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

function Header() {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const [openBranchConf, setOpenBranchConf] = React.useState(false);
  const [openAdminSettings,setOpenAdminSettings]=React.useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  
  const activeLink = useSelector(selectSideBarActiveLink); 
  React.useEffect(() => {
    // Update the document title based on the current route
    document.title = ` ${activeLink || 'Insurance ERP'}`;
  }, [activeLink]);
  React.useEffect(()=>{
    let switchAdminWindow = searchParams.get("switch_admin_wdow");
  
    if(switchAdminWindow=='true'){
      setOpenAdminSettings(true);
    }
  },[])

  const handleMenuClose= (event, reason)=>{
    if (reason && reason == "backdropClick" && "escapeKeyDown") 
    return;
    setOpenAdminSettings(false);
  }

  const closeBranchConfModal = () => {
    setOpenBranchConf(false);
  };
  const userDatas = JSON.parse(localStorage.getItem('userDatas'));

  return (
    <>
      {openAdminSettings && <HeaderAdminbox handleMenuClose={handleMenuClose}/>}
      <HeaderWrapper display="flex" alignItems="center">
      <Box display="flex" alignItems="center">
        <Hidden lgUp>
          <Logo />
        </Hidden>
        <Hidden mdDown>
          <HeaderMenu />
        </Hidden>
      </Box>
      <Box display="flex" alignItems="center">
        {/* <HeaderButtons /> */}
        <ChangeBranch
          openBranchConf={openBranchConf}
          closeBranchConfModal={closeBranchConfModal}
        />
        {userDatas?.userData?.userType != 'SuperAdmin' ? (
          <>
            <UserBoxButton
              color="secondary"
              onClick={() => {
                setOpenBranchConf(true);
              }}
            >
              <Hidden mdDown>
                <UserBoxText>
                  <UserBoxLabel variant="body1">
                    {
                      userDatas?.userData?.activeBranchData?.userBranch
                        ?.branchName
                    }
                  </UserBoxLabel>
                </UserBoxText>
              </Hidden>
              <Hidden smDown>
                <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
              </Hidden>
            </UserBoxButton>
          </>
        ) : null}
        &nbsp;&nbsp;
        <Tooltip title="View Calendar" arrow>
          <Link underline="hover" color="inherit" href="/dashboards/calendar/">
            <img
              width="30"
              height="30"
              src="/static/images/icons/calendar-icon.svg"
            />
          </Link>
        </Tooltip>
        <HeaderUserbox />
        <Hidden lgUp>
          <Tooltip arrow title="Toggle Menu">
            <IconButton color="primary" onClick={toggleSidebar}>
              {!sidebarToggle ? <MenuTwoToneIcon /> : <CloseTwoToneIcon />}
            </IconButton>
          </Tooltip>
        </Hidden>
      </Box>
    </HeaderWrapper>
    </>
   
  );
}

export default Header;
